import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#e30713',
    primaryDark: '#B1060E',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/elmatic-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/elmatic-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/elmatic-logo.png',

    availableProducts: ["Schadenmeldung"],
});